var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveWidgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m900 840.53 10.984 10.984c14.645 14.645 38.387 14.645 53.031 0s14.645-38.387 0-53.031l-75-75c-14.645-14.645-38.387-14.645-53.031 0l-75 75c-14.645 14.645-14.645 38.387 0 53.031s38.387 14.645 53.031 0l10.984-10.984v134.47c0 20.711 16.789 37.5 37.5 37.5s37.5-16.789 37.5-37.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m114.07 151.14c29.547-68.941 97.336-113.64 172.34-113.64h477.18c75.004 0 142.79 44.699 172.34 113.64l76.57 178.66v272.83c89.672 51.875 150 148.82 150 259.87 0 165.69-134.31 300-300 300-111.04 0-207.99-60.328-259.87-150h-340.13c-124.27 0-225-100.73-225-225v-168.75c0-20.711 16.789-37.5 37.5-37.5s37.5 16.789 37.5 37.5v168.75c0 82.844 67.156 150 150 150h309.45c-6.1719-23.973-9.4531-49.102-9.4531-75 0-165.69 134.31-300 300-300 25.898 0 51.027 3.2812 75 9.4531v-196.95h-825v56.25c0 20.711-16.789 37.5-37.5 37.5s-37.5-16.789-37.5-37.5v-101.45zm172.34-38.641c-45.004 0-85.676 26.82-103.41 68.184l-51.133 119.32h355.63v-187.5zm276.09 0v187.5h355.63l-51.133-119.32c-17.73-41.363-58.402-68.184-103.41-68.184zm75 750c0-124.27 100.73-225 225-225s225 100.73 225 225-100.73 225-225 225-225-100.73-225-225z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m262.5 750c-20.711 0-37.5 16.789-37.5 37.5s16.789 37.5 37.5 37.5h93.75c20.711 0 37.5-16.789 37.5-37.5s-16.789-37.5-37.5-37.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveWidgetIcon);
export default __webpack_public_path__ + "static/media/save-widget-icon.a5a22eed50b9df5a952d9cecf50134b0.svg";
export { ForwardRef as ReactComponent };